/* global breakpointMd, windowWidth, attachEvent, slideUp, slideDown */

// **********************************************************
// Main menu dropdown
// **********************************************************
attachEvent('.menu__arrow', 'click', (ev) => {
  if (windowWidth() < breakpointMd) {
    const arrowParent = ev.target.closest('.menu__item');
    const menuDropdown = arrowParent.querySelector('.menu__dropdown');

    if (arrowParent.classList.contains('is-open-submenu')) {
      slideUp(menuDropdown, 300);
      arrowParent.classList.remove('is-open-submenu');
    } else {
      arrowParent.classList.add('is-open-submenu');
      slideDown(menuDropdown, 300);
    }
  }
});

// **********************************************************
// Show overlay
// **********************************************************
const menuItems = document.querySelectorAll('.menu__item');

menuItems.forEach((menuItem) => {
  const menuOverlay = document.querySelector('.menu__overlay');

  const toggleMouse = (value) => {
    menuOverlay.classList.toggle('is-visible', value);
    document.body.classList.toggle('is-overlay-visible', value);
  };

  menuItem.addEventListener('mouseover', () => windowWidth() > breakpointMd && toggleMouse(true));
  menuItem.addEventListener('mouseleave', () => windowWidth() > breakpointMd && toggleMouse(false));
});
